import React, { Component } from 'react';
import { Link } from 'react-scroll';

class HomeHeaderMenuPrimary extends Component {
    constructor() {
        super();
        this.state = {
            over: false,
            pushed: false
        };

        this.scrollEvent = this.scrollEvent.bind( this );
        this.set         = this.set.bind( this );
    };

    componentDidMount() {
        window.addEventListener( 'scroll', this.scrollEvent, { passive: true } );
    };

    componentWillUnmount() {
        window.removeEventListener( 'scroll', this.scrollEvent, { passive: true } );
    };

    removeActive() {
        if ( document.querySelector( '.active' ) ) {
            let actives = document.querySelector( '.active' );

            if ( actives !== null ) {
                actives.classList.remove( "active" );
            }
        }
    };

    scrollEvent() {
        let offset = 76;
        const offsets = [];
        const link_names = [];
        
        offsets.push( document.getElementById( "about-us" ).offsetTop );
        offsets.push( document.getElementById( "appointments" ).offsetTop );
        offsets.push( document.getElementById( "treatments" ).offsetTop );
        offsets.push( document.getElementById( "our-team" ).offsetTop );
        offsets.push( document.getElementById( "contact-us" ).offsetTop );
        offsets.push( document.getElementById( "follow-us" ).offsetTop );

        link_names.push( document.getElementById( "nav-about" ) );
        link_names.push( document.getElementById( "nav-appointments" ) );
        link_names.push( document.getElementById( "nav-treatments" ) );
        link_names.push( document.getElementById( "nav-teams" ) );
        link_names.push( document.getElementById( "nav-contact-us" ) );
        link_names.push( document.getElementById( "nav-follow-us" ) );

        if ( !this.state.pushed ) {
            if ( window.scrollY < offsets[0] ) {
                this.removeActive();
            }

            for (let i = 0; i < offsets.length; i++) {
                if ( window.scrollY + offset > offsets[i] ) {
                    this.removeActive();
                    link_names[i].classList.add( 'active' );
                }  
            }
        }
    };

    handleClick( e ) {
        this.setState( { pushed: true } )
        this.removeActive();

        let active = e.target;
        active.parentNode.classList.add( "active" );

        setTimeout( this.set, 800 );
    };

    set() {
        this.setState( { pushed: false } )
    };

    render() {
        return (
            <nav className="menu-primary">
                <ul className="nav">
                    <li id="nav-about" className="nav-item">
                        <Link onClick={ ( e ) => this.handleClick( e ) } title="About Us" to="about-us" href="#about-us">About Us</Link>
                    </li>

                    <li id="nav-appointments" className="nav-item">
                        <Link onClick={ ( e ) => this.handleClick( e ) } title="Appointments" to="appointments" href="#appointments">Appointments</Link>
                    </li>

                    <li id="nav-treatments" className="nav-item">
                        <Link onClick={ ( e ) => this.handleClick( e ) } title="Treatments" to="treatments" href="#treatments">Treatments</Link>
                    </li>

                    <li id="nav-teams" className="nav-item">
                        <Link onClick={ ( e ) => this.handleClick( e ) } title="Physiotherapist" to="our-team" href="#our-team">Physiotherapist</Link>
                    </li>

                    <li id="nav-contact-us" className="nav-item">
                        <Link onClick={ ( e ) => this.handleClick( e ) } title="Contact Us" to="contact-us" href="#contact-us">Contact Us</Link>
                    </li>
                </ul>
            </nav>
        );
    };
};

export default HomeHeaderMenuPrimary;
